var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_9160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2673 8.06723C12.6828 8.06791 12.1032 8.17309 11.5557 8.37779L17.9112 14.7333C18.1186 14.1791 18.2239 13.5918 18.2218 13C18.216 11.6898 17.6915 10.4351 16.763 9.51068C15.8345 8.58623 14.5776 8.06722 13.2673 8.06723Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7649 12.6606C22.331 8.16112 18.0627 5.43834 13.3394 5.43834C12.0534 5.44136 10.776 5.64857 9.55493 6.05223L10.7177 7.22223C11.5742 7.00089 12.4548 6.88687 13.3394 6.88278C17.4055 6.88278 21.1033 9.15056 23.306 12.9711C22.498 14.3886 21.4268 15.6387 20.1499 16.6544L21.1755 17.68C22.6532 16.4879 23.8805 15.0151 24.7866 13.3467L24.9744 13L24.7649 12.6606Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51733 4.17444L6.73844 7.39555C4.70244 8.70646 3.03842 10.5197 1.90677 12.6606L1.71899 13L1.90677 13.3467C4.34066 17.8461 8.60899 20.5689 13.3323 20.5689C15.1759 20.5685 16.9956 20.1513 18.6551 19.3483L22.2662 22.9594L23.5301 21.8761L4.75233 3.09833L3.51733 4.17444ZM9.51177 10.1689C8.83609 11.1218 8.51938 12.283 8.61774 13.447C8.7161 14.611 9.22318 15.7027 10.0492 16.5287C10.8752 17.3547 11.9668 17.8618 13.1308 17.9601C14.2948 18.0585 15.4561 17.7418 16.409 17.0661L17.5645 18.2217C16.2268 18.7935 14.7871 19.0883 13.3323 19.0883C9.26621 19.0883 5.56844 16.8206 3.36566 13C4.42278 11.1282 5.94524 9.56092 7.78566 8.44999L9.51177 10.1689Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_9160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHidden);
export default __webpack_public_path__ + "static/media/password-hidden.f2c29c4d59b7bab4c0a55f9e736a7a8a.svg";
export { ForwardRef as ReactComponent };